import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const DropCountdown = ({ until, variant = "inline", className = "" }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!until) return null;
  const end = new Date(until).getTime();
  const left = end - now;

  if (Number.isNaN(end) || left <= 0) {
    return (
      <span className={`text-[0.6rem] font-bold uppercase tracking-[0.24em] text-navy/40 ${className}`} data-testid="drop-countdown-closed">
        Drop closed
      </span>
    );
  }

  const d = Math.floor(left / 86400000);
  const h = Math.floor((left % 86400000) / 3600000);
  const m = Math.floor((left % 3600000) / 60000);
  const s = Math.floor((left % 60000) / 1000);

  if (variant === "block") {
    return (
      <div className={className} data-testid="drop-countdown">
        <p className="mb-2.5 text-[0.6rem] font-bold uppercase tracking-[0.28em] text-gold">Drop closes in</p>
        <div className="flex max-w-xs gap-2">
          {[[d, "Days"], [h, "Hrs"], [m, "Min"], [s, "Sec"]].map(([v, l]) => (
            <div key={l} className="min-w-[62px] flex-1 border border-gold/30 bg-gold/5 py-2.5 text-center">
              <p className="font-serif text-xl leading-none text-gold">{pad(v)}</p>
              <p className="mt-1.5 text-[0.52rem] font-bold uppercase tracking-[0.22em] text-navy/50">{l}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <span className={`inline-flex items-center gap-2 text-[0.62rem] font-bold uppercase tracking-[0.22em] text-gold ${className}`} data-testid="drop-countdown">
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-burgundy" />
      Drop closes in {d > 0 ? `${d}d ` : ""}{pad(h)}:{pad(m)}:{pad(s)}
    </span>
  );
};
